import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const getMimeType = (fileName: any) => {
  const extension: any = fileName.split(".").pop().toLowerCase();
  switch (extension) {
    case "pdf":
      return "application/pdf";
    case "doc":
    case "docx":
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case "xls":
    case "xlsx":
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    case "ppt":
    case "pptx":
      return "application/vnd.openxmlformats-officedocument.presentationml.presentation";
    case "txt":
      return "text/plain";
    default:
      return "application/octet-stream";
  }
};

const Downloader = () => {
  const params: any = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAndDownloadFile = async () => {
      const fileName = params["*"].split("/").pop();
      const fileUrl = `${process.env.REACT_APP_MEDIA_URL}/wp-content/uploads/${params["*"]}`;

      try {
        const response = await axios.get(fileUrl, {
          responseType: "blob",
        });

        const mimeType = getMimeType(fileName);
        const blob = new Blob([response.data], { type: mimeType });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        window.close();
      } catch (error) {
        console.error("Error downloading the file:", error);
      }
    };

    fetchAndDownloadFile();
  }, [params, navigate]);

  return <div>Downloading your file...</div>;
};

export default Downloader;
